// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f6051a71","498":"83e66d00","789":"9a61af62"}[chunkId] + ".chunk.js";
};